import {
  winArrowClass,
  winArrowContainerClass,
} from '~/actions/extraHTML/wheelOfFortune/const';

export const winArrow = () => {
  return `<div class='${winArrowContainerClass}'>
      <div class='${winArrowClass}'></div>
    </div>`;
};
